/* eslint no-trailing-spaces: 0 */

const messages = {
  'params': {
    'label': 'Deutsch beta'
  },
  'service': {
    'flow-and-time': 'Menge und Wasserfluss & Zeit',
    'ro-membrane': 'RO Membran Effizienz',
    'temperature': 'Temperatur',
    'leakage': 'Leckerkennung',
    'pressure': 'Wasserdruck',
    'co2': 'CO2-Gas'
  },
  'service-short': {
    'flow-and-time': 'Wasserfluss&Zeit',
    'ro-membrane': 'RO',
    'temperature': 'Temperatur',
    'leakage': 'Leck',
    'pressure': 'Druck',
    'co2': 'CO2'
  },
  'sensor': {
    'flow': 'Durchflusssensor',
    'tds': 'TDS Sensor',
    'temperature': 'Temperatursensor',
    'leakage': 'Lecksensor',
    'pressure': 'Drucksensor'
  },
  'user-params': {
    username: 'Benutzername',
    email: 'E-mail',
    password: 'Passwort',
    password_reinput: 'Passwort (Neueingabe)',
    password_reinput_differs: 'Passwort und Passwort (Neueingabe) sind unterschiedlich.',
    role: 'Rolle'
  },
  'role': {
    'administrator': 'Administrator',
    'manager': 'Manager',
    'staff': 'Mitarbeiter'
  },
  'btn': {
    'add': 'Hinzufügen',
    'edit': 'Bearbeiten',
    'cancel': 'Abrechen',
    'update': 'Akutalisieren',
    'save': 'Sichern',
    'ok': 'OK',
    'delete': 'Löschen'
  },
  'validate': {
    'phone-format': 'Bitte nur Ziffern eingeben',
    'phone-length': 'Telefonnummer muss innerhalb von 128 Ziffern sein',
    'select': 'Bitte auswählen',
    'vali-required': 'Dieses Feld ist Pflicht.'
  },
  cognitoError: {
    UserNotFoundException: 'Benutzername wurde nicht gefunden.',
    UsernameExistsException: 'Benutzer existiert bereits.',
    UserNotConfirmedException: 'Benutzer wurde nicht bestätigt.',
    NotAuthorizedException: 'Falscher Benutzername oder falsches Passwort.',
    LimitExceededException: 'Die Anzahl der Anforderungen überschreitet die maximale Anzahl der Wiederholungen des Systems. Bitte machen Sie eine weitere Anfrage nach einer gewissen Zeit.',
    CodeMismatchException: 'Es stimmt nicht mit dem Bestätigungscode überein, der vom System ausgegeben wurde. Bitte geben Sie den korrekten Bestätigungscode ein.',
    InvalidParameterException: 'Ein ungültiger Wert wurde angegeben.',
    UnknownError: 'Ein unbekannter Fehler ist aufgetreten.'
  },
  signup: {
    signup: 'Benutzerregistrierung',
    register: 'Benutzerregistrierung',
    buy_iotizr: 'Kauf IoTIZR',
    signupConfirmDialogText: 'Möchten Sie sich mit diesem Inhalt registrieren?',
    signupSuccessDialogText:
      'Wir haben eine Anmeldeanfrage erhalten. Sie erhalten eine Bestätigungs-E-Mail an die angegebene E-Mail-Adresse. Bitte klicken Sie auf URL in der E-Mail, dann werden Sie korrekt registriert.'
  },
  'login': {
    'login': 'Anmeldung',
    'lost': 'Haben Sie Ihr Passwort vergessen?',
    'link_to_signup': 'Benutzerregistrierung',
    'vali-username-blank': 'Benutzername wird benötigt.',
    'vali-password-blank': 'Passwort wird benötigt.',
    'next': 'Weiter',
    'incorrect': 'Falscher Benutzername oder Passwort.'
  },
  'resetpassword': {
    'title': 'Passwort zurücksetzen',
    'detail': 'Bitte geben Sie Ihren Benutzernamen ein',
    'entercode': 'Bitte geben Sie den Bestätigungscode ein.',
    'newpassword': 'Neues Passwort',
    'codedetail': 'Eine E-Mail mit einem Bestätigungscode wurde von "no-reply@verificationemail.com" an Ihre registrierte E-Mail-Adresse gesendet. Überprüfen Sie Ihr Postfach und geben Sie den Bestätigungscode ein.',
    'resendcode': 'Code erneut senden',
    'vali-code-blank': 'Verifizierungscode erforderlich.',
    'vali-pass-blank': 'Ein neues Passwort ist erforderlich.',
    'vali-pass-number': 'Das Passwort muss mindestens eine Zahl (0-9) und einen Buchstaben (a-z) beinhalten.',
    'vali-pass-length': 'Das Passwort muss aus mehr als 7 Zeichen bestehen.',
    'vali-pass-whitespace': 'Passwort, die Leerzeichen enthalten, können nicht festgelegt werden.',
    'confirm': 'Bestätigen'
  },
  activate: {
    title: 'Account aktivieren',
    detail: 'Überprüfen Sie Ihr Postfach und geben Sie den Benutzernamen und das vorläufige Passwort ein. Bitte ändern Sie das temporäre Passwort. Bitte neues Passwort eingeben.',
    temp_password: 'Temporäres Passwort',
    newpassword: 'Neues Passwort',
    passwordreinput: 'Neues Passwort (Neueingabe)',
    agreement: 'Nutzungsbedingungen',
    // https://aplix.backlog.com/view/HARPS-641#comment-12816718
    // agreement_msg: 'Dieser Service wird Ihnen von der Aplix Corporation angeboten. Durch die Nutzung dieses Dienstes stimmen Sie den Aplix HARPS-Nutzungsbedingungen zu ( <a href=\'http://www.aplix.co.jp/en/legal/terms_harps.php\' target=\'_blank\'>HARPS Nutzungsbedingungen</a>, <a href=\'http://www.aplix.co.jp/en/privacypolicy/privacypolicy_iot.php\' target=\'_blank\'>Datenschutzrichtlinie für IoT Solurion</a> ) und Schiedsverfahren vor der Internationalen Handelskammer für Streitigkeiten zwischen uns.',
    agree: 'Ich habe diese Bedingungen gelesen und stimme ihnen zu.',
    you_need_to_agree: 'Sie müssen zustimmen',
    submit: 'Absenden',
    complete: 'Aktivierung abgeschlossen'
  },
  'global-menu': {
    'dashboard': 'Home',
    'watersystem': 'Überwachung',
    'customer': 'Standortverwaltung',
    'setting': 'Einstellungen',
    'pc': 'PC Verwaltung'
  },
  'home': {
    'notification': 'Benachrichtigungen',
    'information': 'Von {0}',
    'mail-notification-top': 'E-Mail-Benachrichtigungen sind jetzt verfügbar.',
    'mail-notification-under': 'Bitte bestätigen Sie Ihre Einstellungen <a href=\'{0}\'>hier</a>',
    'quick-link': 'Schnell Link',
    'calendar': 'Wartungskalender',
    'quick-link-settings': 'Schnell Link Einstellungen',
    'notification-alert': 'Alarm-Wert erreicht',
    'notification-warning': 'Warnungs-Wert erreicht'
  },
  'watersystem': {
    'column-nexttime': 'Nächste Ersatzerwartung',
    'customer-name': 'Standortnamen',
    'customer': 'Standort',
    'organization-name': 'Organisation',
    'device-name': 'Gerätename',
    'device': 'Gerät',
    'deviceinfo': 'Geräteinformation',
    'filter-life-left': 'Filterlebensdauer übrig',
    'filter': 'Filter',
    'flow-rate': 'Fließrate',
    'flow': 'Strömung',
    'history': 'Historie',
    'list': 'Auflistung nach',
    'mapinfo': 'Karteninfo',
    'name': 'Name',
    'period-month': 'Monate',
    'purification-amount': 'Menge der Wasserreinigung',
    'RoMembrane': 'RO-Membranentfernungseffizienz',
    'RoMembrane-short': 'RO-Entfernungsrate',
    'RoMembrane-good': 'Gut',
    'RoMembrane-caution': 'Vorsicht',
    'RoMembrane-alert': 'Alarm',
    'Pressure': 'Drucksensor',
    'Pressure-short': 'Drucksensor',
    'Pressure-good': 'Gut',
    'Pressure-caution': 'Vorsicht',
    'Pressure-alert': 'Alert',
    'service': 'Service',
    'status': 'Status',
    'filter-reset': 'Filter zurücksetzen',
    'please-select': 'Bitte wählen Sie ein Gerät aus.',
    'elapsed-time': 'Verstrichene Zeit',
    'total-flow': 'Menge des Wasserflusses',
    'customer-info': 'Ortsinformationen',
    'rest-flow': 'Restwassermengen Flussrate',
    'filter-reset-title': 'Achtung!',
    'filter-reset-text': 'Möchten Sie den Filter wirklich zurücksetzen?',
    'filter-reset-do': 'Zurücksetzen',
    'filter-reset-cancel': 'Abbrechen',
    'threshold': 'Schwellenwert',
    'notification-threshold': 'Benachrichtigungsschwellenwert',
    'about-flow-and-time': 'Über Durchfluss und Zeit Schwellenwert',
    'about-ro-membrane': 'Über RO Membraneffizienzschwellenwert',
    'about-pressure': 'Über Wasser Druckschwellenwert',
    'custom': 'Angepasst',
    'use-preset': 'Verwenden Sie Voreinstellungen',
    'flow-life': 'Strömung Lebensspanne',
    'time-life': 'Zeit Lebensspanne',
    'alert': 'Alarm',
    'warning': 'Warnung',
    'use-flow': 'zu verwendender Durchflusssensor',
    'need-sensor': 'Benötigte Sensoren',
    'about-flow-and-time-text': 'Messen Sie die Wassermenge im Schlauch innerhalb einer bestimmten Zeit. Wir werden eine Benachrichtigung im Laufe der Zeit senden bei Erhöhung der Durchflussrate.',
    'about-ro-membrane-text': 'Installieren Sie an den Einlass / Auslass-2-Ein- / Auslässen der RO-Membran eine Sonde des TDS-Sensors, um den Verunreinigungsgehalt zu messen und berechnen Sie die Verunreinigungs-Entfernungsrate der RO-Membran. Wir senden Ihnen eine Mitteilung bei reduzierter Verunreinigungsentfernungsrate.',
    'about-pressure-text': 'Messen Sie den Druckwert am Einbauort des Sensors. Soweit es die Anzahl der Ports von IoTIZR betrifft, ist es möglich, mehrere zu installieren. Benachrichtigungen über den angegebenen Druck hinaus senden.',
    'about-setting-flow-and-time-text': 'Stellen Sie den Schwellenwert ein, bei dem eine Warnmeldung für die Durchflussrate ([UNIT]) bzw. die Zeit (Monat) ausgegeben wird.',
    'about-setting-ro-membrane-text': 'Sicherheitshinweis / Warnwert mit Verunreinigungsentfernungsrate (%) einstellen.',
    'about-setting-pressure-text': 'Vorsichtswert / Warnwert mit dem Druckwert einstellen.',
    'about-threshold-setting': 'Über die Schwellenwerteinstellung',
    'headline-press-alert': 'Der Druckwert war niedriger als der Warnwert.',
    'headline-press-warning': 'Der Druckwert war niedriger als der Vorsichtswert.',
    'headline-press-normal': 'Zur Zeit sind alle Druckwerte normal.',
    'headline-diff-press-alert': 'Der Differenzdruckwert liegt über dem Warnwert.',
    'headline-diff-press-warning': 'Der Differenzdruckwert liegt außerhalb des Warnwertes.',
    'now-pressure': 'Aktueller Druckwert',
    'vali-threshold-must': 'Benötigte Felder',
    'vali-threshold-num': 'Bitte geben Sie einen numerischen Wert ein',
    'vali-threshold-integer': 'Bitte geben Sie einen Ganzzahlenwert ein',
    'vali-threshold-limit100': 'Bitte geben Sie eine Zahl bis zu 100 ein',
    'vali-threshold-positive-integer': 'Bitte geben Sie eine Zahl größer oder gleich 0 ein',
    'impurities-removal-rate': 'Verunreinigungsentfernungsrate',
    'entrance-impurity-content': 'Der einlaßseitige Verunreinigungsgehalt',
    'exit-impurity-content': 'Auslauf Verunreinigungsgehalt',
    'time-elapsed': 'Verstrichene Zeit',
    'pressure': 'Wasserdruck',
    'setting-link-text1': 'Bitte bearbeiten Sie "Benachrichtigungsschwelle" in den ',
    'setting-link-text2': 'Einstellungen',
    'setting-link-text3': ' zum ändern.',
    'vali-threshold-alert-less-than': 'Bitte geben Sie einen Wert ein, der kleiner als der Alarmwert ist',
    'vali-threshold-greater-than-warning': 'Bitte geben Sie eine Nummer ein, die größer als der Warnwert ist',
    'vali-threshold-warning-less-than': 'Bitte geben Sie einen Wert ein, der kleiner als der Warnwert ist',
    'vali-threshold-greater-than-alert': 'Bitte geben Sie eine Zahl ein, die größer ist als der Alarmwert',
    'last-update': 'Letztes Update',
    'past-pressure': 'Druckwert bei {0}',
    'last-update-for-chart': 'Letztes Update',
    'last-update-week-suffix-for-chart': 'die Woche im Jahr {0}',
    'last-impurities-removal-late': 'Aktueller Verunreinigungsentfernungsrate',
    'past-impurities-removal-late': 'Verunreinigungsentfernungsrate bei {0}',
    'differential-pressure': 'Differenzdruckwert(e)',
    'about-differential-pressure-text': 'Misst den Druckwert von zwei Punkten und berechnet die Differenz (Absolutwert) des Druckwerts. Sendet eine Benachrichtigung, wenn sich der Differenzdruck erhöht.',
    'about-setting-differential-pressure-text': 'Warnungs-/Alarmschwellenwerte des Differenzdruck einstellen.',
    'differential-pressure-need-sensor': 'Zwei Drucksensoren',
    'differential-pressure-value': 'Differenzdruckwert',
    'leakage-all-normal': 'Es gibt momentan kein Wasserleck',
    'return-to-normal': 'Zurück zu keinem Leck',
    'leakage-alert': 'Wasserleck',
    'detection-history': 'Wasserleckgeschichte',
    'no-water-leak-history': 'Es gibt keine Wasserleckgeschichte.',
    'headline-leakage-alert': 'Wir haben Wasser aufgespürt. Bitte überprüfen Sie den Standort.',
    'leakage-normal': 'Kein Leck',
    'leakage': 'Wasserleck sensor',
    'leakage-short': 'Wasserleck sensor'
  },
  'chart': {
    'dataZoom-zoom': 'Zoom',
    'dataZoom-back': 'Zoom zurücksetzen',
    'change-period': 'Änderungszeitraum',
    'button-reload': 'Neu laden',
    'graph-label-fromlastchange': 'Gesamtwasserreinigung seit dem letzten Filterwechsel',
    'graph-label-diff': 'Wasserreinigung während der Zeit',
    'graph-label-sum': 'Vollständige Wasserreinigung',
    '15m': '15 Minuten',
    '1h': '1 Stunde',
    '1d': '1 Tag',
    '1w': '1 Woche',
    '1M': '1 Monat',
    'auto-reload': 'Automatisches Neuladen',
    'label-date': 'Datum',
    'label-time': 'Zeit',
    'button-date-jump': 'Springen',
    'button-date-recent': 'Letzter',
    'button-ok': 'OK',
    'button-cancel': 'Abbrechen',
    'message-oldest': 'Da die Daten des angegebenen Datums und der angegebenen Uhrzeit nicht angezeigt werden können, werden die ältesten Daten angezeigt.',
    'message-latest': 'Da die Daten des angegebenen Datums und der angegebenen Uhrzeit nicht angezeigt werden können, werden die neuesten Daten angezeigt.',
    'message-outbounds-oldest': 'Da die Daten des angegebenen Datums und der angegebenen Uhrzeit nicht vorhanden sind, werden die ältesten Daten angezeigt.',
    'message-outbounds-latest': 'Da die Daten des angegebenen Datums und der angegebenen Uhrzeit nicht vorhanden sind, werden die neuesten Daten angezeigt.',
    'message-no-data': 'Keine Daten vorhanden.'
  },
  'user': {
    'unselected': 'Bitte wählen Sie eine Organisation.',
    'nodata': 'Es gibt keinen Benutzer.',
    'username': 'Benutzername',
    'email': 'E-Mail',
    'role': 'Rolle',
    'edit-setting': 'Einstellungen bearbeiten'
  },
  'organizations': {
    'title': 'Organisationen Liste',
    'button-add': 'Organisation hinzufügen',
    'button-add-pc': 'Fügen Sie P/C hinzu'
  },
  'settings': {
    'title': 'Einstellungen',
    'unit': 'Einheit der Wassermenge',
    'timezone': 'Zeitzone',
    'timezone-location': 'Lokale Zeitzone',
    'pressureUnit': 'Einheit des Drucks',
    'display-setting': 'Darstellungseinstellung',
    'available-sensor': 'Sensoren',
    'life-and-notification': 'Lebensdauer und Benachrichtigungen',
    'notification-presets': 'Benachrichtigungsvoreinstellungen',
    'notification-mail': 'Benachrichtigungsmail',
    'organization-user': 'Organisation und Benutzer',
    'management-organization': 'Organisationsmanagement',
    'user-management': 'Benutzerverwaltung',
    'user-invitation': 'Benutzer hinzufügen',
    'add-organization': 'Organisation hinzufügen',
    'pc-management': 'P/C Management',
    'set-up': 'Aktualisieren'
  },
  'account': {
    'delete-organization': 'Organisation löschen',
    'basic-information': 'Grundinformationen',
    'organization': 'Name der Organisation',
    'parent-organization': 'Elternorganisation',
    'description': 'Beschreibung',
    'tel': 'Telefon',
    'email': 'E-Mail',
    'contact': 'Kontakt',
    'incharge': 'die verantwortliche Person',
    'administrator': 'Administrator',
    'name': 'Name(optional)',
    'username': 'Benutzername des Verantwortlichen',
    'useremail': 'E-Mailadresse des Verantwortlichen',
    'company': 'Firmenname',
    'address': 'Adresse',
    'created': 'Erstellungsdatum',
    'edit': 'Bearbeiten',
    'caution-title': 'Achtung!',
    'caution-org-remove-text': 'Möchten Sie die Organisation wirklich löschen?',
    'caution-user-remove-text': 'Möchten Sie den Benutzer wirklich löschen?',
    'caution-location-remove-text': 'Möchten Sie den Standort wirklich löschen?',
    'delete': 'Löschen',
    'cancel': 'Abbrechen',
    'close': 'Schließen',
    'create': 'Erstellen',
    'updated': 'Aktualisiert',
    'error-delete': 'Konnte nicht gelöscht werden.',
    'error-customer': 'Es sind noch verwandte Orte übrig.',
    'error-user': 'Es gibt einige Benutzer darunter.',
    'error-root': 'Dies ist die root-Organisation.',
    'error-system': 'Es sind noch verwandte Systeme übrig.',
    'header-title': 'Organisation und Benutzerverwaltung',
    'header-org': 'Organisationsmanagement',
    'header-user': 'Benutzerverwaltung',
    'header-invite': 'Benutzer hinzufügen',
    'header-pc': 'P/C Verwaltung',
    'invite-btn': 'Einladungs-E-Mail senden',
    'policy': 'Grundsatzerklärung',
    'agree': 'Akzeptieren',
    'csv-import': 'Die CSV-Importfunktion ist in Planung',
    'label-role': 'Rolle',
    'label-parent': 'Elternorganisation',
    'label-belongto': 'Organisation',
    'label-organization': 'Organisation',
    'label-account': 'Account',
    'label-username': 'Benutzername des Verantwortlichen',
    'label-useremail': 'E-Mail des Verantwortlichen',
    'success-dialog': 'Einladungsnachricht wurde erfolgreich gesendet.',
    'vali-username-must': 'Benutzername ist ein Pflichtfeld.',
    'vali-username-format': 'Kann aus Buchstaben, Zahlen und Symbolen bestehen (. - _ @)',
    'vali-username-char': 'Der Benutzername muss 4-20 Zeichen lang sein.',
    'vali-email-must': 'E-Mail ist ein Pflichtfeld.',
    'vali-email-format': 'Muss gültige E-Mail sein',
    'vali-phone-format': 'Nur Zahlen sind gültig.',
    'vali-phone-length': 'Die Telefonnummer muss aus 128 Ziffern bestehen.',
    'vali-role': 'Bitte auswählen',
    'vali-org-select': 'Bitte auswählen',
    'vali-org-name': 'Der Name der Organisation ist erforderlich.',
    'vali-location-name': 'Der Name des Ortes ist erforderlich.',
    'fail-registration': 'Registrierung fehlgeschlagen',
    'fail-username': 'Der eingegebene Benutzername kann nicht registriert werden'
  },
  'customer': {
    'add': 'Standort hinzufügen',
    'latitude': 'Breitengrad',
    'longitude': 'Längengrad',
    'info': 'Grundinformation',
    'situation': 'Nutzungsbericht',
    'active-device': 'Aktive Geräte',
    'others': 'Andere',
    'geo-location': 'Breitengrad / Längengrad',
    'defined': 'eingetragen.',
    'undefined': 'undefiniert.',
    'situation-title': 'Zusammenfassung',
    'print': 'Drucken',
    'target': 'Ziel',
    'sum': 'Summe',
    'history': 'Historie',
    'iotizr-situation': 'Situation des IoTIZR',
    'service-plan': 'Serviceplan',
    'device-customer': 'Gerät (Ort)',
    'date': 'Datum',
    'name': 'Standortnamen',
    'device': 'Gerät',
    'organization': 'Organisation',
    'address': 'Adresse',
    'tel': 'Telefon',
    'open-map': 'Zahlen von Karte holen',
    'close-map': 'Karte schließen',
    'content': 'Inhalt',
    'get-address': 'Adresse bekommen',
    'search': 'Suche',
    'error-location': 'Längengrad und Breitengrad konnte nicht identifiziert werden',
    'error-delete': 'Löschen fehlgeschlagen.',
    'error-delete-connecting-device': 'Entfernen Sie den/die IoTIZR von diesem Ort zuerst mit dem HARPS Toolkit und versuchen Sie es erneut.',
    'success-delete': 'Löschen erfolgreich.'
  },
  'notifications': {
    'header-title': 'Lebensdauer von Verbrauchsmaterialien und Benachrichtigungen',
    'header-preset': 'Benachrichtigungsvoreinstellungen',
    'header-mail': 'Benachrichtigungsmail',
    'title-mail': 'Benachrichtigungsmail',
    'title-langage': 'Landeseinstellung',
    'japanese': 'Japanisch',
    'english': 'Englisch',
    'enable': 'Bekommen',
    'disable': 'Nicht bekommen'
  },
  'profile': {
    'profile': 'Dein Profil',
    'role': 'Rolle',
    'organization': 'Organisation',
    'email': 'E-Mail',
    'new-email': 'Neue E-Mail',
    'change-email': 'E-Mail ändern',
    'change-password': 'Passwort ändern',
    'old-password': 'Aktuelles Passwort',
    'new-password': 'Neues Passwort',
    'confirm-new-password': 'Neues Passwort bestätigen',
    'cancel': 'Abbrechen',
    'change': 'Ändern',
    'submit': 'Absenden',
    'confirm': 'Bestätigen',
    'resend': 'E-Mail erneut senden',
    'continue': 'Weiter',
    'confirmation-code': 'Geben Sie Ihren Bestätigungscode ein',
    'confirmation-code-input': 'Geben Sie den Bestätigungscode ein',
    'change-password-error': 'Altes Passwort falsch.',
    'not-verified': 'Ihre E-Mail-Adresse wurde nicht bestätigt',
    'verify': 'Überprüfen',
    'verified': 'Ihre E-Mail-Adresse ist verifiziert',
    'vali-blank-new-pass': 'Bitte geben Sie das neue Passwort ein',
    'vali-blank-old-pass': 'Bitte geben Sie das aktuelle Passwort ein',
    'vali-blank-confirm-new-pass': 'Bitte bestätigen Sie das neue Passwort',
    'vali-format': 'Muss mindestens 8 Zeichen lang sein und mindestens eine Zahl (0-9) enthalten',
    'vali-length': 'Muss innerhalb von 25 Ziffern liegen',
    'vali-same-password': 'Bitte geben Sie das gleiche Passwort wie oben ein.',
    'vali-empty-code': 'Geben Sie den Bestätigungscode ein',
    'vali-email-format': 'bitte geben Sie eine gültige E-Mail Adresse an',
    'vali-invalid-code': 'Bestätigungscode ist falsch',
    'code-confirm-text1': 'Eine E-Mail mit einem Bestätigungscode wurde an Ihre registrierte E-Mail-Adresse gesendet.',
    'code-confirm-text2': 'Überprüfen Sie Ihr Postfach und geben Sie den Bestätigungscode ein.',
    'code-confirm-title': 'Geben Sie den Bestätigungscode ein',
    'code-confirm-input': 'Bestätigungscode',
    'change-email-title': 'E-Mail ändern',
    'change-password-title': 'Passwort ändern',
    'success-resend': 'Eine E-Mail mit einem Bestätigungscode wurde an Ihre registrierte E-Mail-Adresse gesendet.\n Falls die E-Mail nicht zugestellt wird, versuchen Sie es bitte nach ein wenig Zeit erneut.',
    'fail-resend': 'Erneut senden fehlgeschlagen',
    'fail-error': 'Versuch Limit überschritten, bitte versuchen Sie es nach einiger Zeit.',
    'changed-password': 'Ihr Passwort wurde aktualisiert'
  }
}

module.exports = messages



// WEBPACK FOOTER //
// ./src/assets/aqua_harps4_com/translations/german.js